import { Checkbox, Input, FormGroup, Box, H2 } from '@bigcommerce/big-design';

export function ContactDetailsForm(props) {
	const { getCustomerValue, setCustomerInformation } = props;

	const maskPhoneNumber = (e) => {
		const oldPhoneValue = e;
		const newPhoneValue = oldPhoneValue.replace(
			/^(\d{3})(\d{3})(\d+)$/,
			'$1-$2-$3',
		);
		setCustomerInformation('phone', newPhoneValue);
	};

	return (
		<Box padding="large">
			<H2>Contact Details</H2>
			<FormGroup>
				<Input
					label="First Name"
					required
					value={getCustomerValue('first_name')}
					onChange={(e) =>
						setCustomerInformation('first_name', e.target.value)
					}
				/>
				<Input
					label="Last Name"
					required
					type="text"
					value={getCustomerValue('last_name')}
					onChange={(e) =>
						setCustomerInformation('last_name', e.target.value)
					}
				/>
				<Input
					label="Phone Number"
					required
					type="tel"
					placeholder="___-___-____"
					value={getCustomerValue('phone')}
					onChange={(e) => {
						maskPhoneNumber(e.target.value);
					}}
				/>
				<Input
					label="Email"
					required
					type="text"
					value={getCustomerValue('email')}
					onChange={(e) =>
						setCustomerInformation('email', e.target.value)
					}
				/>
				<Checkbox
					label="Send Order Confirmation"
					checked={
						getCustomerValue('send_order_confirm') === ''
							? true
							: getCustomerValue('send_order_confirm')
					}
					onChange={(e) => {
						setCustomerInformation(
							'send_order_confirm',
							e.target.checked,
						);
					}}
				/>
			</FormGroup>
		</Box>
	);
}
